import { createFileRoute } from '@tanstack/react-router'
import { AlertDetailPage } from '@/features/compliance/alert-detail-page'
import { requirePermission } from '@/lib/route-guards'

/** Detalle y resolución de una alerta de cumplimiento. */
export const Route = createFileRoute('/_app/compliance/alerts/$alertId')({
  beforeLoad: requirePermission('compliance:read'),
  component: AlertDetailRoute,
})

function AlertDetailRoute() {
  const { alertId } = Route.useParams()
  return <AlertDetailPage alertId={alertId} />
}
